import React, { useState } from 'react';
import nav from './Navigation.module.css'
import { NavLink } from 'react-router-dom';
// https://solocomrade1101.github.io/React_Applications.github.io/
// https://solocomrade1101.github.io/

// http://localhost:3003/React_Applications.github.io
// http://localhost:3003/*
// http://localhost:3003/
function Navigation(props) {
  const path = '/React_Applications.github.io'

  const [active, setActive] = useState(true)

  function getActiveClass(e){
    console.log(e)
  }

  return (
    <div4 onClick={getActiveClass}className={nav.block}>
      <div className={nav.link} ><NavLink  to="/React_Applications.github.io" className={nav.nav_link} activeClassName="active" >Змейка</NavLink></div>
      <di1 className={nav.link} ><NavLink to="/calculator" className={nav.nav_link} activeClassName="active" >Калькулятор</NavLink></di1>
      <di2 className={nav.link} ><NavLink to="/casino" className={nav.nav_link} activeClassName="active" >Казино</NavLink></di2>
      <div className={nav.link} ><NavLink to="/tictactoe" className={nav.nav_link} activeClassName={"active"} >Крестики-нолики</NavLink></div>
    </div4>
  );
}

export default Navigation;